module.exports = __webpack_public_path__ + "static/media/working couple_afcolisson_202004.0454a409.jpg";